import { useContext } from "react";
import { ThemeContext } from "../context/ThemeContext";
import type {} from '@mui/x-data-grid/themeAugmentation';
import type {} from '@mui/x-data-grid-pro/themeAugmentation';

const useTheme = () => useContext(ThemeContext);

export default useTheme;
